export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8334.98e9429f.jpg";